import { post, get, put, deleteApi } from './axiosFun';
// 任务分类分页
export const taskTypePage = (params) => { return post(`/train/task-type/page`, params) };
export const taskTypeList = (params) => { return post(`/train/task-type/list`, params) };

export const taskTypeAdd = (params) => { return post(`/train/task-type/add`, params) };

export const taskTypeEdit = (params) => { return put(`/train/task-type/edit`, params) };

export const taskTypeDetails = (taskTypeId) => { return get(`/train/task-type/detail/${taskTypeId}`) };

export const taskTypeRemove = (params) => { return deleteApi(`/train/task-type/remove`, params) };



// WEBPACK FOOTER //
// ./src/api/taskType.js